import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';

@Injectable()
export class ReportService {
  // tslint:disable-next-line:one-line
  constructor(private http: HttpClient, private httpClientService: HttpClientService,
  private utilityService: UtilityService) { }


  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

  fetchJSON(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers())
    .pipe(
       map((res: HttpResponse<any>) => {
      if (sessionStorage.getItem('sapmp_jwtToken') != null) {
        // refreshes token for logged in scenario upon page load
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      }
     return res.body;
     })
      ,catchError( this.handleError ));
  }

  setRequestObject(obj: any) {
    sessionStorage.setItem('selectedReportType', obj.type);
    sessionStorage.setItem('selectedReportFormat', obj.format);
  }

  getReportObject() {
    return ({ type: sessionStorage.getItem('selectedReportType'), format: sessionStorage.getItem('selectedReportFormat')});
  }
  doRequestReport(url) {
    return this.httpClientService.get(url, this.get_headers())
    .pipe(
       map((test: HttpResponse<any>) => {
      if (sessionStorage.getItem('sapmp_jwtToken') != null) {
        // refreshes token for logged in scenario upon page load
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      }
     return test.body; })
      ,catchError( this.handleError ));
  }

  getFANList() {
    let fanUrl;
    fanUrl = this.utilityService.getEnvConfig().getFANList;
    return this.fetchJSON(fanUrl);
  }

  handleError = (error) => {
    return throwError(error);
  }
}
